import React from "react";
import styles from "./styles.module.css";
import {timeAgo} from "../Marque/time";
import {useNavigate} from "react-router-dom";

const LatestCard = ({post}) => {
	const navigate = useNavigate();

	if (!post) return null;

	const someDate = new Date(post?.createdAt);

	const clickHandler = () => {
		navigate(`/post/${post._id}`, {state: post});
	};

	return (
		<article className={styles.card} onClick={clickHandler}>
			<div className={styles.cardCont}>
				<img
					src={post?.images?.[0]}
					alt={post?.title || "Latest news"}
					className={styles.image}
					loading="lazy"
				/>

				<div className={styles.overlay}>
					<span className={styles.badge}>Latest News</span>

					<div className={styles.text}>
						<h1>{post?.title}</h1>

						<div className={styles.meta}>
							{post?.author && <span>{post.author}</span>}
							<span>{timeAgo(someDate)}</span>
						</div>
					</div>
				</div>
			</div>
		</article>
	);
};

export default LatestCard;
